import React, { useEffect, useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./AddTeamMember.module.css";
import TextArea from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
const AddTeamMember = ({
  show,
  setShow,
  handleAddTeamMember,
  isEdit,
  setIsEdit,
  loading,
  modalLoading,
}) => {
  const [active, setactive] = useState("original");
  const [text, setText] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,"
  );
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const handleSubmit = async() => {
    const data = {
      userName: name,
      surName: surname,
      email,
      ...(!isEdit ? { password, passwordConfirm } : null),
    };
    await handleAddTeamMember(data);

  };
  useEffect(() => {
    if (isEdit) {
      setName(isEdit?.userName);
      setSurname(isEdit?.surName);
      setEmail(isEdit?.email);
    }
    return () => {
      setIsEdit(null);
    };
  }, []);

  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"689px"}
        //   header={"Login"}
        borderRadius={"20px"}
        //   showCloseIcon
      >
        <div className={classes.main}>
          <div className={classes.header}>
            <div
              className={[
                classes.btn,
                active === "original" && classes.active,
              ].join(" ")}
              onClick={() => {
                setactive("original");
              }}
            >
              <h3>{isEdit ? "Edit" : "Add"} Team Member</h3>
              <div className={classes.input_main}>
                <Input placeholder={"Name"} value={name} setter={setName} />
                <Input
                  placeholder={"Surname"}
                  value={surname}
                  setter={setSurname}
                />
                <Input placeholder={"Email"} value={email} setter={setEmail} />
                {!isEdit && (
                  <>
                    <Input
                      type="password"
                      placeholder={"Password"}
                      value={password}
                      setter={setPassword}
                    />
                    <Input
                      type="password"
                      placeholder={"Confirm Password"}
                      value={passwordConfirm}
                      setter={setPasswordConfirm}
                    />
                  </>
                )}

                <Button
                  btnColor
                  green={isEdit ? true : false}
                  onClick={handleSubmit}
                  customStyle={{ width: "100%" }}
                  label={
                    modalLoading
                      ? "Please Wait..."
                      : isEdit && !modalLoading
                      ? "Edit Member"
                      : "Add Member"
                  }
                />
              </div>
            </div>
          </div>
          {/* <div
            className={classes.crossBtn}
            onClick={() => {
              setShow(false);
            }}
          >
            <RxCross2 size={20} color={"var(--white-color"} />
          </div> */}
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default AddTeamMember;
